















import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import FilterSwitch from '@components/044-FilterSwitch/FilterSwitch.vue';
import { IContentFilter } from '@frontend/types/modules/content-filter/IContentFilter';

@Component({
	hydration: true,
	componentId: 'C045',
	components: {
		FilterSwitch
	}
})
export default class FilterGroup extends Vue {
	@Prop(String)
	protected readonly label?: string;

	@Prop(String)
	protected readonly groupId!: string;

	@Prop(Boolean)
	protected readonly hidden?: boolean;

	@Prop(Array)
	protected readonly filters!: IContentFilter[];

	protected onChange(checked: boolean, value: string): void {
		const filters = JSON.parse(JSON.stringify(this.filters));

		filters.forEach((item: IContentFilter, index: number) => {
			if (item.value === value) {
				filters[index].checked = checked;
			}
		});

		this.$emit('input', { groupId: this.groupId, filters });
	}
}
